import { render, staticRenderFns } from "./DetailsDrawer.vue?vue&type=template&id=fb97058e&scoped=true"
import script from "./DetailsDrawer.vue?vue&type=script&lang=js"
export * from "./DetailsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb97058e",
  null
  
)

export default component.exports